import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { Persona } from '../../models/persona';

@Injectable({
  providedIn: 'root'
})
export class PersonaService {

  headers: HttpHeaders; 
  tvcModulo;
  url;
  constructor(private http: HttpClient, private utilService: UtilsService) {
    this.tvcModulo = moduloPerform;
    this.url = this.utilService.getQueryTvc( this.tvcModulo.url.datosMaestros.persona);
    // this.url = " http://localhost:8080/tvc/v1/api/fe/persona"
  }

  getAll() {
    const headers = this.utilService.getHeaders();
    return this.http.get<Persona []>( this.url, {headers});
  }

  save( innPersona ) {
    const headers = this.utilService.getHeaders();
    return this.http.post<Persona>(this.url, innPersona, { headers});
  }

  update( innPersona) {
    const headers = this.utilService.getHeaders();
    return this.http.put<Persona>(this.url, innPersona, { headers});
  }

  delete( inId ) {
    const headers = this.utilService.getHeaders();
    return this.http.delete(this.url + '/' + inId, { headers});
  }

  getLineaPersonasPorUsuario() {
    const headers = this.utilService.getHeaders();
    return this.http.get<any []>( this.url + '/' + this.tvcModulo.url.parada.getLineasPersonas + '/' + localStorage.getItem('userName'),
                               {headers});
  }//


}//